import React, { useEffect } from "react";
import OrderTable from "./MaterialTable/OrderTable";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CardLoaderComponent from "../../../CardLoaderComponent";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";

const NewQuotesWidget = (props) => {
  const { tableData, isLoading, isNewQuotesDataAvailable } = props;

  const theme = createTheme({
    palette: {
      primary: { main: "#367C2B" },
      secondary: { main: "#FFDE00" },
    },
    typography: { useNextVariants: true },
  });

  useEffect(() => {}, []);

  return (
    <>
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-1">
          <h2 className="text-zinc-900 text-xl font-semibold font-['Open Sans'] leading-7">
            New Quotes
          </h2>
          <h2 className="text-zinc-900 text-xl font-semibold font-['Open Sans'] leading-7">
            ({tableData.length})
          </h2>
        </div>
        <a
          className="text-lime-700 text-sm font-semibold font-['Open Sans'] leading-tight"
          href="/forwarder/quoting/forwarder-orders"
        >
          <Tooltip title="Go to Quotes page">
            <IconButton>
              <ArrowForwardIcon />
            </IconButton>
          </Tooltip>
        </a>
      </div>
        <ThemeProvider theme={theme}>
          {isLoading && (
            <CardLoaderComponent
              desc="new quotes"
              subtitle="This might take a while"
            />
          )}
          {!isLoading && isNewQuotesDataAvailable && (
            <div className="h-44">
              <OrderTable tableData={tableData}></OrderTable>
            </div>
          )}
          {!isNewQuotesDataAvailable && !isLoading && (
            <h6 className="flex justify-center flex-col h-44 text-center">
              No records to display
            </h6>
          )}
        </ThemeProvider>
    </>
  );
};

export default NewQuotesWidget;
